import { Link } from "react-router-dom";
import Timeline from "../elements/Timeline";

function Me() {
  function getAge() {
    const birthDate = new Date(1998, 5, 1); // Year, Month (0-11), Day
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  return (
    <div className="page">
      <div className="mebox">
        <img src="img/me.webp" className="meimg" alt="Über mich" />
        <div className="meboxpadding">
          <h1 className="notselectable">Über mich</h1>
          <div className="button notselectable center">
            <Link className="buttonLink" to="/kontakt">
              Lernen Sie mich kennen
            </Link>
          </div>
          <h2 className="notselectable">LEIDENSCHAFT</h2>
          <p className="notselectable">
            Mein Beruf ist Berufung. Ich brenne für die Pharmazie und Apotheken.
            Keine teuren Büroräume, kein gestriegelter Anzug, keine Phrasen von
            Brachenfremden. Vertrauen Sie auf jemanden, dem der Erfolg von
            öffentlichen Apotheken und Ihr Wohl wirklich am Herzen liegt.
          </p>
          <h2 className="notselectable">ERFAHRUNG</h2>
          <p className="notselectable">
            Man muss nicht erst 50 werden, um von sich behaupten zu können,
            erfahren zu sein. Mit meinen {getAge()} Jahren, etlichen Praktika,
            zahlreichen Jobs und zwei hervorragend abgeschlossenen Studiengängen
            habe ich mehr gelernt und gesehen als Andere in einem ganzen Leben.
          </p>
          <h2 className="notselectable">KOMPETENZ</h2>
          <p className="notselectable">
            Durch Einser-Abschlüsse sowohl in Wirtschaftswissenschaften als auch
            der Pharmazie gepaart mit Allgemeinwissen, Charme, Witz und
            rhetorischem Können vereine ich, was Sie zu Recht erwarten. Ob ADG,
            Awinta oder Pharmatechnik - Phoenix, Sanacorp oder Noweda - VSA, DRZ
            oder ARZ - Dorf-, Innenstadt- oder Centerapotheke: Ich kenne alles.
            Die Zahlen, die Menschen, die Herausforderungen. Aber vor allem
            Anderen: Die Potenziale.
          </p>
          <h2 className="notselectable">LEBENSLAUF</h2>
          <div className="timelineparent">
            <Timeline />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Me;
